/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Tab_GeneralInputs */

const en_task_flow_tab_general = /** @type {(inputs: Task_Flow_Tab_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

const pt_br2_task_flow_tab_general = /** @type {(inputs: Task_Flow_Tab_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geral`)
};

/**
* | output |
* | --- |
* | "General" |
*
* @param {Task_Flow_Tab_GeneralInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_tab_general = /** @type {((inputs?: Task_Flow_Tab_GeneralInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Tab_GeneralInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_tab_general(inputs)
	return pt_br2_task_flow_tab_general(inputs)
});